const f = str => {
  let res = '';
  for(const i of str) {
    if(i===' ') {
      res += '_';
    } else {
      res += i;
    }
  }
  return res;
};

export default f;